import React, { useEffect, useRef, useState } from "react";
import { Dialog } from "@mui/material";
import { ReactComponent as CrossIcon } from "assets/img/svg/CrossIcon.svg";
import styles from "./styles.module.scss";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import AInput from "views/pages/manage/common/formFeilds/customInput/AInput";
import ReleaseStatListing from "./ReleaseStatListing";


const ReleaseStratDialog = ({ rows = [], loading = false, isOpenRel, setIsOpenRel }) => {
    const [releaseRowList, setReleaseRowList] = useState(rows?.Release_details);
    // const isViewMode = isOpenRel?.mode === "view";

    return (
        <Dialog open={!!isOpenRel} PaperProps={{ sx: { maxWidth: "unset", borderRadius: "12px" } }}>
            <div className={`${styles["select-concession-popup"]}`}>
                <div className="d-flex justify-content-between">
                    <div className="heading-4 color-dark">Release Strategy</div>
                    <div style={{ marginLeft: "auto" }}>
                        <CrossIcon
                            width={24}
                            height={24}
                            onClick={() => {
                                setIsOpenRel(null);
                            }}
                        />
                    </div>
                </div>

                <div className="d-flex justify-content-between">
                    <AInput
                        value={rows?.Release_group}
                        placeholder={""}
                        disabled={true}
                        label={"Release Group"}
                    />

                    <AInput
                        value={rows?.Release_strategy}
                        placeholder={""}
                        disabled={true}
                        label={"Release Stategy"}
                    />

                    <AInput
                        value={rows?.Release_indicator}
                        placeholder={""}
                        disabled={true}
                        label={"Release Indicator"}
                    />
                </div>

                <div>
                    <ReleaseStatListing
                        rows={releaseRowList}
                    />
                    <div className="mt-3">
                        <AButton
                            variant="primary_filled"
                            onClick={() => {
                                setIsOpenRel(false);
                            }}
                            size="xs"
                        >
                            Done
                        </AButton>
                    </div>
                </div>
            </div>
        </Dialog>
    )
}

export default ReleaseStratDialog